import React, { useEffect, useState, memo, useRef, useContext } from "react";
import "primereact/resources/themes/saga-orange/theme.css";
import "primeicons/primeicons.css";
import "../../../node_modules/primeflex/primeflex.css";
import Table from "../../components/Table/Table";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ConfirmDialog } from "primereact/confirmdialog";
import {
  createCreditInvoiceColumns,
  rowExpansionCreateCreditInvoiceLineItemColumns
} from "../../constants/table-columns/tableColumns";
import { createCreditInvoiceTableHeader } from "../../components/Table/table-header/tableHeader";
import { createCreditInvoiceFooter } from "../../components/Table/table-footer/tablefooter";
import * as constants from "../../constants/constants";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import styles from "./process-credit-invoices.module.scss";
import Spinner from "../spinner/spinner";
import { appInsights } from "../../AppInsights";
import { sendProcessedData } from "../../services/creditInvoiceService";

const ProcessCreditInvoices = (props) => {
  const { processedData, clearForm } = props;
  const statusList = [
    { label: "Error", value: 2 },
    { label: "Success", value: 1 }
  ];
  const toast = useRef(null);
  const [processeData, setProcesseData] = useState(processedData);
  const [errorCount, setErrorCount] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchInvoiceId, setSearchInvoiceId] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [allExpanded, setAllExpanded] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  //TODO :Remove (Info: Need to do whether should we be validate error with zero quantity)
  const [errorExceptZeroChecked, setErrorrExceptZeroChecked] = useState(false);

  useEffect(() => {
    onClear();
    const errorRecords = processedData?.filter((item) => item?.errors != null);
    setErrorCount(errorRecords?.length);
  }, [processedData]);

  const filterContent = (
    selectedStatus,
    invoiceNumber,
    errorExceptZeroChecked
  ) => {
    let filterContent = processedData;
    if (selectedStatus) {
      filterContent = filterContent?.filter((item) => {
        if (selectedStatus === 1 && item?.errors == null) {
          return item;
        } else if (selectedStatus === 2 && item?.errors != null) {
          return item;
        }
      });
    }
    if (invoiceNumber?.trim() != "") {
      filterContent = filterContent?.filter((item) =>
        item?.invoiceNumber?.toLocaleLowerCase()?.includes(invoiceNumber)
      );
    }
    if (invoiceNumber?.trim() == "") {
      filterContent = filterContent?.filter(
        (item) =>
          item?.invoiceNumber?.toLocaleLowerCase()?.includes(invoiceNumber) ||
          item?.invoiceNumber == null
      );
    }

    //TODO :Remove errorExcept Zero Checked
    if (errorExceptZeroChecked) {
      filterContent = filterContent?.filter((item) => {
        if (
          item?.errors == null ||
          item.errors?.length > 1 ||
          validateErrorWithZero(item?.errors)
        ) {
          return item;
        }
      });
    }
    //TODO :Remove errorExcept Zero Checked
    if (!errorExceptZeroChecked) {
      filterContent = filterContent?.filter((item) => {
        return item;
      });
    }

    setProcesseData(filterContent);
  };

  const onStatusSelect = (event) => {
    const data = event?.value?.label ? event?.value?.value : event?.value;
    setSelectedStatus(data);
    //TODO : remove errorExceptZeroChecked
    if (searchInvoiceId?.trim() == "" && !errorExceptZeroChecked) {
      const filteredData = processedData?.filter((item) => {
        if (data === 1 && item?.errors == null) {
          return item;
        } else if (data === 2 && item?.errors != null) {
          return item;
        }
      });
      setProcesseData(filteredData);
    } else {
      filterContent(data, searchInvoiceId, errorExceptZeroChecked);
    }
  };

  const onSearch = (event) => {
    const value = event?.target?.value?.toLocaleLowerCase();
    setSearchInvoiceId(value);
    if (selectedStatus == null && value?.trim() !== "") {
      const filteredData = processedData?.filter((item) =>
        item?.invoiceNumber?.toLocaleLowerCase()?.includes(value)
      );
      setProcesseData(filteredData);
    } else {
      filterContent(selectedStatus, value, errorExceptZeroChecked);
    }
  };

  //TODO: Remove
  const onErrorExceptZeroSelect = (event) => {
    setErrorrExceptZeroChecked(event?.checked);
    if (
      selectedStatus == null &&
      searchInvoiceId?.trim() == "" &&
      event?.checked
    ) {
      const filteredData = processedData?.filter((item) => {
        if (
          item?.errors == null ||
          item.errors?.length > 1 ||
          validateErrorWithZero(item?.errors)
        ) {
          return item;
        }
      });
      setProcesseData(filteredData);
    } else {
      filterContent(selectedStatus, searchInvoiceId, event?.checked);
    }
  };

  //TODO: Remove
  const validateErrorWithZero = (errors) => {
    if (errors[0]?.includes("Quantity is zero or empty")) {
      return false;
    } else {
      return true;
    }
  };

  const onCreateAndTransmitCreditInvoiceClick = async () => {
    setShowSpinner(true);
    try {
      const errorCount = processeData?.filter((item) => item?.errors !== null);
      if (errorCount?.length === processeData.length) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No Success Records to move forward!",
          life: 4000
        });
      } else {
        let filterSuccessFulProcessedRecords = processeData
          .filter((item) => item?.errors == null)
          .map(({ id, errors, lineItems, regionCode, ...rest }) => {
            const cleanLineItems = lineItems
              ? lineItems.map(({ errors, ...rest }) => rest)
              : [];

            return {
              ...rest,
              ...(cleanLineItems
                ? { lineItems: cleanLineItems, region: regionCode }
                : [])
            };
          });

        await sendProcessedData(filterSuccessFulProcessedRecords);
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail:props.denialReasonSelected
          ? "Data saved to Reports successfully"
          : "Credit invoices have been created successfully",
          life: 4000
        });
        clearForm();
      }
    } catch (error) {
      toast?.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo:
            "Error while submitting Saving credit invoices grid data"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
    setShowSpinner(false);
  };

  const onClear = () => {
    setProcesseData(processedData);
    setSelectedStatus(null);
    setSearchInvoiceId("");
    setErrorrExceptZeroChecked(false);
  };

  const errorBodyTemplate = (rowData) => {
    return rowData?.errors?.join(", ");
  };

  const handleConfirmationDialog = () => {
    props?.handleConfirmation();
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div
        className="p-1 pl-5 ml-5"
        style={{ width: "60%", minWidth: "10rem" }}
      >
        <DataTable
          value={data?.lineItems}
          paginatorTemplate={constants?.paginatorTemplate}
          paginator={constants?.paginator}
          rows={constants?.defaultRows}
          rowsPerPageOptions={constants?.rowsPerPageOptions}
          currentPageReportTemplate={constants?.currentPageReportTemplate}
          emptyMessage={constants?.emptyMessage}
        >
          {rowExpansionCreateCreditInvoiceLineItemColumns?.map((col, index) => (
            <Column
              key={index}
              field={col?.field}
              header={col?.header}
              sortable={col?.sort}
              style={{ minWidth: col?.minWidth }}
              frozen={col?.frozen || false}
              body={
                col?.columnType?.toLowerCase() === "fun"
                  ? col?.columnDefination
                  : col?.field?.toLowerCase() === "errors"
                  ? errorBodyTemplate
                  : col?.value || null
              }
            />
          ))}
        </DataTable>
      </div>
    );
  };
  const toggleRows = () => {
    if (allExpanded) {
      setExpandedRows(null);
      setAllExpanded(false);
    } else {
      let newExpandedRows = {};
      //Info : invoiceNumber is unique field
      processeData.forEach(
        (p) => (newExpandedRows[`${p?.invoiceNumber}`] = true)
      );
      setExpandedRows(newExpandedRows);
      setAllExpanded(true);
    }
  };
  return (
    <>
      {showSpinner && <Spinner />}
      {errorCount > 0 && (
        <div className={styles?.errorContainer}>
          <span>
            {" "}
            <i className="pi pi-info-circle"> </i> There are {errorCount} errors
            in the data.
          </span>
        </div>
      )}
      <div>
        <DataTable
          value={processeData}
          tableStyle={constants?.tableStyle}
          paginatorTemplate={constants?.paginatorTemplate}
          paginator={constants?.paginator}
          scrollable={constants?.scrollable}
          rows={constants?.defaultRows}
          dataKey="invoiceNumber"
          className={`${constants?.tableStyle?.dataTable} copydatatable`}
          rowsPerPageOptions={constants?.rowsPerPageOptions}
          emptyMessage={constants?.emptyMessage}
          currentPageReportTemplate={constants?.currentPageReportTemplate}
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          header={(copyTable, isCopyEnable, data) =>
            createCreditInvoiceTableHeader({
              selectedStatus,
              onStatusSelect,
              onErrorExceptZeroSelect,
              errorExceptZeroChecked,
              statusList,
              styles,
              searchInvoiceId,
              onSearch,
              onClear,
              data
            })
          }
          footer={() =>
            createCreditInvoiceFooter({
              styles,
              setShowConfirmDialog,
              processeData,
              handleConfirmationDialog,
              denialReasonSelected: props.denialReasonSelected
            })
          }
        >
          <Column
            header={
              <Button
                className={
                  allExpanded ? "pi pi-angle-down" : "pi pi-angle-right"
                }
                style={{
                  fontSize: "1.3rem",
                  color: "#6c757d",
                  backgroundColor: "#f8f9fa",
                  border: "none",
                  padding: "2px"
                }}
                onClick={toggleRows}
              ></Button>
            }
            frozen="true"
            style={{ width: "10px" }}
            expander={true}
          />
          {createCreditInvoiceColumns?.map((col, i) => (
            <Column
              key={col?.field}
              field={col?.field}
              header={col?.header}
              sortable={col?.sort}
              frozen={col?.frozen || false}
              style={{ minWidth: col?.minWidth }}
              headerStyle={{ minWidth: col?.minWidth }}
              body={
                col?.columnType?.toLocaleLowerCase() === "fun"
                  ? col?.columnDefination
                  : col?.field?.toLocaleLowerCase() === "errors"
                  ? errorBodyTemplate
                  : null
              }
            />
          ))}
        </DataTable>

        {showConfirmDialog && (
          <ConfirmDialog
            visible={showConfirmDialog}
            onHide={() => setShowConfirmDialog(false)}
            message={
              <>
                <div style={{ marginTop: "10px" }}>
                  Only success Credit Invoices will be processed. Do you want to
                  continue?
                </div>
                <div>
                  <i
                    className="pi pi-times-circle"
                    style={{ color: "red" }}
                  ></i>{" "}
                  Error Records: {errorCount}
                </div>
                <div>
                  <i
                    className="pi pi-check-circle"
                    style={{ color: "green" }}
                  ></i>{" "}
                  Successful Records: {processedData.length - errorCount}
                </div>
              </>
            }
            header="Confirmation"
            icon="pi pi-exclamation-triangle"
            style={{ width: "50vw", color: "red" }}
            breakpoints={{ "1100px": "75vw", "960px": "100vw" }}
            accept={() => onCreateAndTransmitCreditInvoiceClick()}
          ></ConfirmDialog>
        )}

        <Toast ref={toast} position="center" />
      </div>
    </>
  );
};
export default memo(ProcessCreditInvoices);
